import { Components, Theme } from '@mui/material';

const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    }),
    list: ({ theme }) => ({
      gap: theme.spacing(theme.spacingSizes.lg),
    }),
    indicator: ({ theme }) => ({
      backgroundColor: theme.palette.grey[900],
    }),
  },
};

export default MuiTabs;
